/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type contactDealerAuthHandlerUserMetadataQueryVariables = {
    readonly email?: string | null;
};
export type contactDealerAuthHandlerUserMetadataQueryResponse = {
    readonly viewer: {
        readonly userExistsMetadata: {
            readonly userExists: boolean | null;
            readonly emailOnly: boolean | null;
            readonly hasPassword: boolean | null;
        } | null;
    } | null;
};
export type contactDealerAuthHandlerUserMetadataQuery = {
    readonly response: contactDealerAuthHandlerUserMetadataQueryResponse;
    readonly variables: contactDealerAuthHandlerUserMetadataQueryVariables;
};



const node: ConcreteRequest = (function () {
    var v0 = [
        ({
            "kind": "LocalArgument",
            "name": "email",
            "type": "String",
            "defaultValue": ""
        } as any)
    ], v1 = [
        ({
            "kind": "Variable",
            "name": "email",
            "variableName": "email"
        } as any)
    ], v2 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "userExists",
        "args": null,
        "storageKey": null
    } as any), v3 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "emailOnly",
        "args": null,
        "storageKey": null
    } as any), v4 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "hasPassword",
        "args": null,
        "storageKey": null
    } as any), v5 = ({
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
    } as any);
    return {
        "kind": "Request",
        "fragment": {
            "kind": "Fragment",
            "name": "contactDealerAuthHandlerUserMetadataQuery",
            "type": "RootQueryType",
            "metadata": null,
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "userExistsMetadata",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "UserExistsMetadataType",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/)
                            ]
                        }
                    ]
                }
            ]
        },
        "operation": {
            "kind": "Operation",
            "name": "contactDealerAuthHandlerUserMetadataQuery",
            "argumentDefinitions": (v0 /*: any*/),
            "selections": [
                {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "viewer",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "Viewer",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "userExistsMetadata",
                            "storageKey": null,
                            "args": (v1 /*: any*/),
                            "concreteType": "UserExistsMetadataType",
                            "plural": false,
                            "selections": [
                                (v2 /*: any*/),
                                (v3 /*: any*/),
                                (v4 /*: any*/),
                                (v5 /*: any*/)
                            ]
                        },
                        (v5 /*: any*/)
                    ]
                }
            ]
        },
        "params": {
            "operationKind": "query",
            "name": "contactDealerAuthHandlerUserMetadataQuery",
            "id": "ferrum/231.0.0-2019-09-05T13:45:49.487Z/contactDealerAuthHandlerUserMetadataQuery",
            "text": null,
            "metadata": {}
        }
    } as any;
})();
(node as any).hash = '7e73d5a22aa8b4869c2dfcfd9aa7d9a5';
export default node;
